export const FirebaseConfig = {
  apiKey: 'AIzaSyAVowrC9tKPWcggBD5LUDdzV92P2HQR5rU',
  authDomain: 'audiolibros-cae3d.firebaseapp.com',
  databaseURL: 'https://audiolibros-cae3d.firebaseio.com',
  projectId: 'audiolibros-cae3d',
  storageBucket: 'audiolibros-cae3d.appspot.com',
  messagingSenderId: '584547193826'
};
